import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

function animateGroup(selector, fromVars) {
  const parents = new Set(
    gsap.utils.toArray(selector).map((el) => el.parentElement)
  );
  parents.forEach((parent) => {
    const els = parent.querySelectorAll(selector);
    gsap.from(els, {
      ...fromVars,
      scrollTrigger: {
        trigger: parent,
        start: 'top 85%',
      },
    });
  });
}

animateGroup('.ani-fadein', {
  opacity: 0,
  delay: 0.2,
  duration: 0.8,
  ease: 'power2.out',
  stagger: 0.15,
});

animateGroup('.ani-fadein-up', {
  opacity: 0,
  y: 30,
  delay: 0.2,
  duration: 0.8,
  ease: 'power2.out',
  stagger: 0.15,
});



const needle = document.getElementById('needle');

if (needle) {
  const npsscore = needle.getAttribute('data-percent');
  const counter = document.getElementById('counter');

  gsap.to(counter, {
    innerHTML: npsscore,
    duration: 5,
    onUpdate: function() {
      counter.innerHTML = Math.round(counter.innerHTML);
    },
    ease: "power1.out"
  });

  gsap
    .timeline({
      defaults: { duration: 5, ease: "power1.out" },
      yoyo: false,
      repeat: 0,
    })
    .to("#needle", { rotation: (180 * 0.5 + (180 * (1 - ((200 - npsscore) / 200)))), svgOrigin: "230 224" }, 0);
}


